import { type NodeReducer } from './';

const hardBreak: NodeReducer = () => {
	return '\n';
};

export default hardBreak;
